import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./DataTypeDemo.css";

const DataTypeDemo = () => {
  const steps = [
    { code: "x = 20", name: "x", value: "20", type: "int" },
    { code: "x = 3.14", name: "x", value: "3.14", type: "float" },
    { code: "x = 'hello'", name: "x", value: "'hello'", type: "str" },
    { code: "x = True", name: "x", value: "True", type: "bool" },
    { code: "x = None", name: "x", value: "None", type: "NoneType" },
  ];

  const [step, setStep] = useState(0);

  const handleNext = () => {
    if (step < steps.length - 1) setStep(step + 1);
  };

  const current = steps[step];

  return (
    <div className="data-type-demo">
      <h3>Динамическая типизация в Python</h3>

      <div className="code-block">
        <pre><code>{current.code}</code></pre>
      </div>

      <div className="variable-box">
        <AnimatePresence exitBeforeEnter>
          <motion.div
            key={current.value}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            className="variable-card"
          >
            <div className="var-name">{current.name}</div>
            <div className="var-value">{current.value}</div>
            <div className={`var-type var-type-${current.type.toLowerCase()}`}>{current.type}</div>
          </motion.div>
        </AnimatePresence>
      </div>

      <button
        className="new-button"
        onClick={handleNext}
        disabled={step >= steps.length - 1}
      >
        {step < steps.length - 1 ? "Следующий пример" : "Готово ✅"}
      </button>
    </div>
  );
};

export default DataTypeDemo;